module.exports = __webpack_public_path__ + "static/img/calendar-illustration.fcb4640.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/currencyIcon/calendar-illustration.png
// module id = ylAt
// module chunks = 1